import { render, staticRenderFns } from "./premium.vue?vue&type=template&id=9e5e68f4&"
import script from "./premium.vue?vue&type=script&lang=js&"
export * from "./premium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports